import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=59684eeb&"
import script from "./BasePage.vue?vue&type=script&lang=ts&"
export * from "./BasePage.vue?vue&type=script&lang=ts&"
import style0 from "./BasePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports